import React, { useEffect, useState } from 'react';
import TokenForm, { TokenStats, TokenStatsWithoutId } from '../components/Token/TokenForm';
import Client from '../utils/network';
import { ObjectId } from 'bson';
import Button from '../components/UI/Button';

const defaultStats: TokenStatsWithoutId = {
    image: '',
    width: 1,
    height: 1,
    borderColor: '#00000000',
    effects: [],
    stats: {
        name: '',
        description: '',
        abilities: {
            strength: 10,
            dexterity: 10,
            constitution: 10,
            intelligence: 10,
            wisdom: 10,
            charisma: 10,
        },
        actions: [],
        skills: {},
        counters: [],
        savingThrows: {},
    },
    assignedUsers: [],
};

export const TokenOverview = () => {
    const [tokens, setTokens] = useState<TokenStats[]>([]);
    const [editingId, setEditingId] = useState<ObjectId>();
    const [formState, setFormState] = useState<'CREATE'|'UPDATE'>('CREATE');
    const [tokenData, setTokenData] = useState<TokenStatsWithoutId>(defaultStats);

    const loadTokens = () => {
        Client.request('/api/token').then(async (res) => {
            const body = await res.json() as TokenStats[];
            setTokens(body);
            return;
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    };

    useEffect(() => {
        loadTokens();
    }, []);

    const selectToken = (id: ObjectId) => {
        setEditingId(id);
    };

    useEffect(() => {
        if(editingId) {
            Client.request(`/api/token/${editingId.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((res) => {
                return res.json();
            }).then((res) => {
                setTokenData(res as TokenStatsWithoutId);
                setFormState('UPDATE');
                return;
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });
        }
    }, [editingId]);

    const onSubmit = (data: TokenStatsWithoutId) => {
        try {
            Client.request('/api/token', {
                method: formState === 'CREATE'
                    ? 'POST'
                    : 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: data,
                }),
            }).then(async (res) => {
                const data = await res.json() as TokenStatsWithoutId;
                if(formState === 'CREATE') {
                    setFormState('UPDATE');
                    setTokenData(data);
                    setEditingId(data?._id);
                }

                loadTokens();
                return;
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.log(err);
            });

        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
        }
    };

    const createNewToken = () => {
        setEditingId(undefined);
        setFormState('CREATE');
        setTokenData(defaultStats);
    };

    const onDelete = () => {
        if(!editingId) {
            return;
        }
        Client.request(`/api/token/${editingId.toString()}`, {
            method: 'DELETE',
        }).finally(() => {
            loadTokens();
            createNewToken();
        }).catch(() => {
            // do nothing
        });
    };

    return (
        <div className="flex flex-row items-stretch">
            <div className='p-2 '>
                <Button
                    className="mb-3 w-fit"
                    onClick={() => createNewToken()}
                >
                    Create
                </Button>
                <div className={
                    'flex flex-col overflow-y-auto overflow-x-hidden'
                    + ' pretty-scroll gap-x-8 gap-y-4 rounded-sm rounded-md'}>
                    {tokens.map((token) => (
                        <>
                            <div
                                className='block w-32 min-h-full flex'
                                key={token._id?.toString()}
                                onClick={() => selectToken(token._id)}
                            >
                                <div className='p-4 bg-mid-blue rounded-md'>
                                    <div>{token?.stats?.name}</div>
                                    <img
                                        src={`${Client.getBaseUrl()}/api/image/${token.image}/thumbnail`}
                                    />
                                </div>
                            </div>
                        </>
                    ))}
                </div>
            </div>
            <div>
                <TokenForm onSubmit={onSubmit} externalData={tokenData} />
                {editingId && (
                    <Button className="mt-3" onClick={onDelete}>
                        Delete
                    </Button>
                )}
            </div>
        </div>

    );
};

export default TokenOverview;
